"use client"
import {
  LineChart
} from "./chunk-ZWA4FO4Q.mjs";

// src/components/radial-chart.ts
import { mergeMultiStyle } from "@yamada-ui/core";
var RadialChart = mergeMultiStyle(
  LineChart,
  {
    baseStyle: {
      background: {
        fill: "transparent"
      },
      cursor: {
        stroke: "none"
      },
      labelList: {
        fill: "white"
      },
      polarGrid: {
        stroke: ["blackAlpha.400", "whiteAlpha.400"],
        strokeWidth: 1
      }
    },
    sizes: {}
  }
)({ omit: ["line", "grid"] });

export {
  RadialChart
};
//# sourceMappingURL=chunk-U3XTSZYI.mjs.map